import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getDetergent, updateDetergent } from '@/apis/detergents'
import useNotification from '@/hooks/useNotification'
import { GetDetergentRequest } from '@/types/apis/detergents/GetDetergentRequest'
import { GetDetergentResponse } from '@/types/apis/detergents/GetDetergentResponse'
import { UpdateDetergentRequest } from '@/types/apis/detergents/UpdateDetergentRequest'
import { UpdateDetergentResponse } from '@/types/apis/detergents/UpdateDetergentResponse'

export const useUpdateDetergents = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<UpdateDetergentResponse>()
  const update = useCallback(
    async (request: UpdateDetergentRequest) => {
      try {
        setLoading(true)
        const res = await updateDetergent(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.update.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.update.fail') })
      } finally {
        setLoading(false)
      }
    },
    [openNotification, t]
  )

  return {
    loading,
    updateDetergent: update,
    response,
  }
}

export const useGetDetergent = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetDetergentResponse>()

  const get = useCallback(async (request: GetDetergentRequest) => {
    try {
      setLoading(true)
      const res = await getDetergent(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getDetergent: get,
    response,
  }
}
